import React, { forwardRef, HTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './Card.module.scss';
// import { ICardProps } from './types';
import CardHeader from './CardHeader';
import CardBody from './CardBody';
import CardFooter from './CardFooter';
import CardTitle from './CardTitle';

export interface ICardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'size'> {
  size?: 'sm' | 'md';
  variant?: 'gray' | 'light' | 'danger';
  noBorder?: boolean
}

interface CardComponent
  extends React.ForwardRefExoticComponent<ICardProps & React.RefAttributes<HTMLDivElement>> {
  Header: typeof CardHeader;
  Body: typeof CardBody;
  Footer: typeof CardFooter;
  Title: typeof CardTitle;
}

const CardRoot = forwardRef<HTMLDivElement, ICardProps>(
  ({
    className, size = 'md', variant = 'gray', noBorder, children, ...props
  }, ref) => (
    <div
      className={classNames(
        styles.card,
        styles[variant],
        styles[size],
        className,
        { [styles.noBorder]: !!noBorder },
      )}
      ref={ref}
      {...props}
    >
      {children}
    </div>
  ),
);

CardRoot.displayName = 'Card';

const Card = CardRoot as CardComponent;
Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;
Card.Title = CardTitle;

export default Card;
